import type { RouteObject } from 'react-router';

import { ContentEditPage } from './ContentEdit';

/**
 * `/content/:contentItemId/edit`. One `RouteObject`, so the file is
 * `.route.tsx` singular.
 *
 * **There is no `/content/:contentItemId` route**, which is why the breadcrumb
 * here carries three levels and not four: a crumb states a position in the URL,
 * and one that led nowhere would be worse than a shallower trail.
 */
export const contentEditRoute: RouteObject = {
  path: 'content/:contentItemId/edit',
  element: <ContentEditPage />,
};
